import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  SimpleTable,
  Pagination,
} from "adminlte-2-react";
import _ from "lodash";
import DatePicker from "react-datepicker";
import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";
import { Modal } from "react-bootstrap";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import Tag from "../utils/Tag";
import { responseSelector } from "../utils/helpers/selectors";
import SelectInput from "../utils/SelectInput";

const { Text } = Inputs;

const estadoOptions = () => [
  { value: "ACTIVO", label: "ACTIVO" },
  { value: "PENDIENTE", label: "PENDIENTE" },
  { value: "INACTIVO", label: "INACTIVO" },
];

function SuscripcionesByLocal({ history, match }) {
  const dispatch = useDispatch();

  const modelSuscripciones = useSelector((state) => state.suscripcionesByLocal);
  const modelDelete = useSelector((state) => state.deleteSuscripcion);
  const modelAjustarSuscripcion = useSelector((state) => state.ajustarSuscripcion);


  const [suscripciones, setSuscripciones] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [ci, setCi] = useState("");
  const [nombre, setNombre] = useState("");
  const [estado, setEstado] = useState("");
  const [show, setShow] = useState(false);
  const [cantidad, setCantidad] = useState(0);
  const [fechaVencimiento, setFechaVencimiento] = useState(null)
  const [suscripcionActiva, setSuscripcionActiva] = useState(null);



  useEffect(() => {
    const data = modelDelete?.data?.data;
    const error = modelDelete?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.deleteSuscripcionDuck.actions.clear());
    }
    if (data) {
      handlePage(0);
      dispatch(controller.deleteSuscripcionDuck.actions.clear());
    }
  }, [modelDelete]);

  useEffect(() => {
    const data = modelAjustarSuscripcion?.data?.data;
    const error = modelAjustarSuscripcion?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      hideModalSuscripcion()
      dispatch(controller.ajustarSuscripcionDuck.actions.clear());
    }
    if (data) {
      handlePage(0);
      hideModalSuscripcion()
      dispatch(controller.ajustarSuscripcionDuck.actions.clear());
    }
  }, [modelAjustarSuscripcion]);

  useEffect(() => {
    const { data, error } = responseSelector(modelSuscripciones);

    if (error) {
      alert(error);
      dispatch(controller.suscripcionesByLocalDuck.actions.clear());
    }
    if (data) {
      setSuscripciones(data.items);
      setTotalResults(data.total);

      dispatch(controller.suscripcionesByLocalDuck.actions.clear());
    }
  }, [modelSuscripciones]);

  useEffect(() => {
    dispatch(
      controller.suscripcionesByLocalThunk(
        match.params.localId,
        1,
        pageSize,
        ci,
        nombre,
        estado
      )
    );
  }, []);

  function handlePage(page) {
    setActivePage(page);
    setSuscripciones([]);
    dispatch(
      controller.suscripcionesByLocalThunk(
        match.params.localId,
        page + 1,
        pageSize,
        ci,
        nombre,
        estado
      )
    );
  }

  function showModalSuscripcion(mostrar, suscripcion) {
    setShow(mostrar);
    setSuscripcionActiva(suscripcion);
    setFechaVencimiento(Date.parse(suscripcion.finalDate));
  }

  function hideModalSuscripcion() {
    setShow(false);
    setSuscripcionActiva(null);
    setCantidad(0);
    setFechaVencimiento(null);
  }

  function guardarEdicion() {
    if (suscripcionActiva) {

      const ussage = suscripcionActiva.ussage;
      ussage.capacity.total = Number(ussage.capacity.total) + Number(cantidad)
      ussage.capacity.left = Number(ussage.capacity.left) + Number(cantidad)
      const data = {
        _id: suscripcionActiva._id,
        ussage,
        finalDate: fechaVencimiento,
        cantidad,
        createdBy: localStorage.getItem("userId")
      }

      dispatch(controller.ajustarSuscripcionThunk(data));
    }
    else {
      hideModalSuscripcion();
    }


  }

  return (
    <Content
      title="Lista de suscripciones"
      subTitle="Lista de suscripciones"
      browserTitle="Lista de suscripciones"
      show={false}
    >
      <Row>
        <Col md="12">
          <Box title="Lista de suscripciones">
            <Col md="12">
              <Modal
                show={show}
                style={{ opacity: 1, paddingTop: 200 }}
                onHide={() => {
                  hideModalSuscripcion();
                }}
              >
                <Modal.Header closeButton={false}>
                  <Modal.Title>Editar suscripcion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Text
                    labelPosition="above"
                    label="Cantidad a agregar o descontar"
                    inputType="number"
                    value={cantidad}
                    onChange={(evt) => setCantidad(evt.target.value)}
                  />
                  <label>
                    <Etiqueta texto="Fecha de vencimiento" obligatorio={false} />
                  </label>
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    customInput={<input type="text" className="form-control" />}
                    selected={fechaVencimiento}
                    onChange={(date) => setFechaVencimiento(date)}
                  />
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    type="primary"
                    text="Guardar"
                    onClick={() => guardarEdicion()}
                  />
                </Modal.Footer>
              </Modal>
              <Col md="3">
                <Text
                  labelPosition="above"
                  size="sm"
                  label="Documento"
                  value={ci}
                  onChange={(evt) => setCi(evt.target.value)}
                />
              </Col>

              <Col md="3">
                <Text
                  labelPosition="above"
                  size="sm"
                  label="Nombre"
                  value={nombre}
                  onChange={(evt) => setNombre(evt.target.value)}
                />
              </Col>

              <Col md="3">
                <SelectInput
                  value={estado}
                  setValue={setEstado}
                  label="Estado"
                  options={estadoOptions()}
                />
              </Col>



              <Col md="3">
                <div style={{ marginTop: 15 }}>
                  <Button
                    type="primary"
                    text="Filtrar"
                    onClick={() => handlePage(0)}
                  />
                </div>
              </Col>
            </Col>
            <Col md="12">
              <div style={{ marginTop: 15 }}>
                <Button
                  type="primary"
                  text="Agregar"
                  pullRight={true}
                  onClick={() =>
                    history.push(`/crearSuscripcion/${match.params.localId}`)
                  }
                />
                <div>
                  <span>Total: {totalResults}</span>
                </div>
              </div>
            </Col>
            {suscripciones && suscripciones.length > 0 ? (
              <SimpleTable
                hover={true}
                data={suscripciones.map((row, index) => {
                  return {
                    ci: row.ci,
                    nombrePersona: row.nombrePersona,
                    nombre: row.description,
                    tipo: row.groupLabel.toUpperCase(),
                    cupos: row.ussage.capacity.left,
                    estado: row.estado,
                    vencimiento: moment(row.finalDate).format("DD-MM-YYYY"),
                    eliminar: (
                      <Button
                        type="danger"
                        text="Eliminar"
                        onClick={() =>
                          dispatch(
                            controller.deleteSuscripcionThunk({ _id: row._id })
                          )
                        }
                      />
                    ),
                    comentario: (
                      <Button
                        type="warning"
                        text="Editar"
                        onClick={() =>
                          showModalSuscripcion(
                            true,
                            row
                          )
                        }
                      />
                    ),
                  };
                })}
                columns={[
                  { title: "Documento", data: "ci" },
                  { title: "Nombre", data: "nombrePersona" },
                  { title: "Plan", data: "nombre" },
                  { title: "Tipo de plan", data: "tipo" },
                  { title: "Reservas restantes", data: "cupos" },
                  { title: "Estado", data: "estado" },
                  { title: "Vencimiento", data: "vencimiento" },
                  { title: "Eliminar", data: "eliminar" },
                  { title: "Editar", data: "comentario" },
                ]}
              />
            ) : (
              <Col md="12">
                <h4>No se han encontrado resutlados</h4>
              </Col>
            )}
            <Pagination
              activePage={activePage}
              pageSize={pageSize}
              totalElements={totalResults}
              onChange={handlePage}
              labels={{
                first: 'Primera',
                last: 'Última',
                previous: 'Anterior',
                next: 'Siguiente',
              }}
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default SuscripcionesByLocal;
